import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./SupportPlanGate.module.css";

/**
 * Aviso inline exibido SOMENTE no fluxo de criação de chamado quando o tenant
 * não tem plano com suporte por chamado. Aparece abaixo do botão "+ Novo
 * chamado" — pré-check via `usePlanFeature("support").allowed === false` OU
 * como defesa em profundidade se o backend responder 403 no POST.
 *
 * Nunca exibe erro técnico nem abre modal/toast — apenas convida ao upgrade
 * em linguagem humana.
 */
export default function SupportPlanGate({ upgradeUrl = "/subscription/plans" }) {
  return (
    <section className={styles.gate} aria-label="Abertura de chamados indisponível no plano atual">
      <span className={styles.lock} aria-hidden="true">
        🔒
      </span>
      <div className={styles.body}>
        <p className={styles.title}>
          Abertura de chamados não está disponível no seu plano atual.
        </p>
        <p className={styles.text}>
          Faça upgrade para ter acesso ao suporte da equipe Nexus e abrir
          chamados sempre que precisar de ajuda.
        </p>
        <Link to={upgradeUrl} className={styles.btn}>
          Ver planos
        </Link>
      </div>
    </section>
  );
}

SupportPlanGate.propTypes = {
  upgradeUrl: PropTypes.string,
};
